/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setweekdayhours2Inputs */

const en_setweekdayhours2 = /** @type {(inputs: Setweekdayhours2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Weekday Hours`)
};

const de_setweekdayhours2 = /** @type {(inputs: Setweekdayhours2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitszeiten an Wochentagen festlegen`)
};

/**
* | output |
* | --- |
* | "Set Weekday Hours" |
*
* @param {Setweekdayhours2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const setweekdayhours2 = /** @type {((inputs?: Setweekdayhours2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setweekdayhours2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_setweekdayhours2(inputs)
	return de_setweekdayhours2(inputs)
});
export { setweekdayhours2 as "setWeekdayHours" }